<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import app from "../stores/app";
    import user from "../stores/user";
    import transfers from "../stores/transfers";
    import R, {LOADER} from "../lib/requests";
    import {ROUTE_TYPES} from "../lib/constants";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {getDate} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import Pagination from "../components/Pagination.svelte";
    import DriverControl from "../components/controls/DriverControl.svelte";
    import LocationControl from "../components/controls/LocationControl.svelte";
    import DepartmentControl from "../components/controls/DepartmentControl.svelte";
    import TransfersTable from "./TransfersTable.svelte";
    import TransfersGrid from "./TransfersGrid.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import TransferView from "./TransferView.svelte";

    const pageHeaderControls = [
        {id: 'create', name: 'CREATE TRANSFER', link: '/app/new-transfer', class: 'hidden-xs'},
        {
            id: 'create',
            name: '',
            icon: 'plus-circle',
            link: '/app/new-transfer',
            class: 'hidden-xl hidden-lg hidden-md hidden-sm'
        },
        {id: 'tour', name: 'CREATE TOUR', link: '/app/new-tour', class: 'hidden-xs'},
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const transferStatus = [
        {id: 0, name: 'Open'},
        {id: 1, name: 'Assigned'},
        {id: 2, name: 'Closed'},
        {id: 3, name: 'Canceled'},
    ];

    const itemsPerPage = [20, 50, 100, 500];

    let routeTypes = [];
    let viewId = null;

    const load = (loader = null) => {
        const onSuccess = result => {
            $transfers.list = result.transfers;
            $transfers.total = result.total;
            $transfers.driver = result.driver;
            $transfers.location = result.location;
        }

        const onFailure = err => {
            let message = err.message ? err.message : "There was an error occurred while loading transfers.";
            Alert.warning("Transfers", message);
        };

        $transfers.search.status_id = `${$transfers.statusId}`;
        $transfers.search.offset = ($transfers.page - 1) * $transfers.search.limit;

        if (loader == null) {
            loader = LOADER.PAGE;
        }

        R.handle(R.transfer.index, $transfers.search, onSuccess, onFailure, loader);
    }

    const search = () => {
        $transfers.page = 1;

        if ($transfers.search.transfer_from && $transfers.search.transfer_to && $transfers.search.transfer_from > $transfers.search.transfer_to) {
            $transfers.search.transfer_to = $transfers.search.transfer_from;
        }

        load();
    }

    const clearSearch = () => {
        transfers.clearSearch();
        load();
    }

    const onPageChange = ({detail}) => {
        $transfers.page = detail;
        load();
    }

    const onColumnSort = ({detail}) => {
        $transfers.search.sort_field = detail.key;
        $transfers.search.sort_way = detail.sort_way;
        load();
    }

    const onDriverChange = ({detail}) => {
        $transfers.search.driver_id = detail ? detail.id : null;
        search();
    }

    const onLocationChange = ({detail}) => {
        $transfers.search.location_id = detail ? detail.id : null;
        search();
    }

    const onDepartmentChange = ({detail}) => {
        $transfers.search.department_id = detail ? detail.id : null;
        search();
    }

    const onEdit = ({detail:transfer_id}) => {
        $transfers.selectedId = transfer_id;
        $transfers.scrollY = window.scrollY;
        if (transfers.isTour(transfer_id)) {
            router.go(`/app/tour/${transfer_id}`)();
        } else {
            router.go(`/app/transfer/${transfer_id}`)();
        }
    }

    const onView = ({detail:transfer_id}) => {
        viewId = transfer_id;
    }

    const onDelete = ({detail}) => {
        Alert.delete("Delete", `This will permanently delete transfer "${detail.code}".\nAre you sure?`, () => deleteTransfer(detail.id));
    }

    const deleteTransfer = (id) => {
        const onSuccess = result => {
            $transfers.list = $transfers.list.filter(x => x.id !== result);
            $transfers.total--;
            Notifier.showMessage("Transfer deleted");
        }

        const onFailure = err => {
        };

        R.handle(R.transfer.delete, id, onSuccess, onFailure, LOADER.POPUP);
    }

    const initialize = () => {
        routeTypes = [{id: '', name: 'route type'}];
        Object.keys(ROUTE_TYPES).map(key => {
            routeTypes.push({id: key, name: ROUTE_TYPES[key]});
        });

        // get search criteria from url parameters
        if (window.location.search) {
            let arr = window.location.search.replace("?", "").split("&");
            arr.map(item => {
                let param = item.split("=");
                if (param[0] === 'date') {
                    $transfers.search.transfer_from = param[1];
                    $transfers.search.transfer_to = param[1];
                    $transfers.list = null;
                } else if (param[0] === 'driver_id') {
                    $transfers.search.driver_id = param[1];
                    $transfers.list = null;
                } else if (param[0] === 'location_id') {
                    $transfers.search.location_id = param[1];
                    $transfers.list = null;
                }
            });
        }

        if (!$transfers.list) {
            if (!$transfers.search.transfer_from) {
                $transfers.search.transfer_from = getDate();
            }

            $transfers.page = 1;
            $transfers.search.limit = itemsPerPage[0];

            load();
        } else if ($transfers.changed) {
            // transfer data changed from TransferEdit
            load(LOADER.NONE);
            $transfers.changed = false;
        }

        if ($transfers.scrollY != null) {
            // set window scroll position to last edited transfer
            setTimeout(function () {
                window.scrollTo({top: $transfers.scrollY});
                $transfers.scrollY = null;
            }, 50);

        }
    }

    initialize();
</script>

<!--<Route exact>-->
<PageHeader title="Transfers" controls={ pageHeaderControls } on:reload={ load }/>

<div class="transfer-filters panel-filters mb-5">
    <div class="d-xl-flex border-bottom-dotted">
        <div class="d-xl-flex d-lg-flex d-md-flex">
            <div class="d-flex dates text-gray ">
                <div class="filter-col d-flex align-items-center">
                    <DateControl placeholder="transfer date" bind:value="{ $transfers.search.transfer_from }"
                           on:change="{ search }"/>
                </div>
                <div class="filter-col d-flex align-items-center">
                    <DateControl placeholder="to" bind:value="{ $transfers.search.transfer_to }"
                           on:change="{ search }"/>
                </div>
            </div>
            <div class="d-flex  states">
                <div class="filter-col ">
                    <select class="form-select" bind:value="{ $transfers.search.route_type }"
                            on:change="{ search }">
                        {#each routeTypes as item}
                            <option value="{ item.id }">{ item.name }</option>
                        {/each}
                    </select>
                </div>
                <div class="filter-col">
                    <select class="form-select" bind:value="{ $transfers.statusId }"
                            on:change="{ search }">
                        <option value="">status</option>
                        {#each transferStatus as item}
                            <option value="{ item.id }">{ item.name }</option>
                        {/each}
                    </select>
                </div>
            </div>
        </div>

        <div class="d-xl-flex d-lg-flex d-md-flex customer">
            <div class="filter-col name d-flex ">
                <AppIcon icon="search" size="18" cssClass="icon-gray me-2 hidden-lg hidden-md hidden-sm hidden-xs"/>
                <input type="text" class="form-control px-2"
                       bind:value="{ $transfers.search.fullname }"
                       on:change="{ search }"
                       placeholder="customer name, email or phone">
            </div>
            <div class="d-flex">
                <div class="filter-col room-no-flight ">
                    <input type="text" class="form-control px-2"
                           bind:value="{ $transfers.search.room_no }"
                           on:change="{ search }" placeholder="room no">
                </div>
                <div class="filter-col room-no-flight">
                    <input type="text" class="form-control px-2"
                           bind:value="{ $transfers.search.flight_no }"
                           on:change="{ search }" placeholder="flight or boat">
                </div>
            </div>
        </div>
    </div>

    <div class="d-xl-flex d-lg-flex d-md-flex">
        <div class="d-xl-flex d-lg-flex d-md-flex more">
            <div class="filter-col ">
                <DriverControl driver={$transfers.driver} css="px-2" placeholder="driver"
                               on:change={ onDriverChange } disabled="{ !user.isAdmin() }"/>
            </div>
            <div class="filter-col ">
                <LocationControl location={$transfers.location} css="px-2" placeholder="location"
                                 on:change={ onLocationChange }/>
            </div>
            <div class="filter-col">
                <DepartmentControl bind:department={$transfers.department} css="px-2"
                                   placeholder="department"  disabled="{ !user.isAdmin() }"
                                   on:change={ onDepartmentChange }/>
            </div>
        </div>
        <div class="d-flex buttons justify-content-end">
            <div class="filter-col">
                <button class="btn btn-default" on:click="{ clearSearch }">CLEAR</button>
            </div>
            <div class="filter-col">
                <button class="btn btn-outline" on:click="{ search }">SEARCH</button>
            </div>
        </div>
    </div>
</div>

<div class="mb-4">
    <div class="row">
        <div class="col-xl-2">
            <select class="form-select form-select-sm" bind:value="{ $transfers.search.limit }" on:change="{ search }">
                {#each itemsPerPage as item}
                    <option value="{ item }">display { item } / page</option>
                {/each}
            </select>
        </div>
    </div>
</div>
{#if $transfers.list}
    {#if $transfers.list.length}
        {#if $app.device === 'lg'}
            <TransfersTable on:sort="{ onColumnSort }"
                            on:edit="{ onEdit }"
                            on:view="{ onView }"
                            on:delete="{ onDelete }"/>
        {:else}
            <TransfersGrid on:edit="{ onEdit }" on:view="{ onView }"/>
        {/if}
        <Pagination itemsPerPage="{ $transfers.search.limit }" totalItems="{ $transfers.total }"
                    page="{ $transfers.page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel border-default">
            <div class="panel-body panel-pad">
                No transfers found.
            </div>
        </div>
    {/if}
{/if}
{#if viewId != null}
    <TransferView bind:transferId="{ viewId }"/>
{/if}

<style>
    .transfer-filters {

    }

    @media (max-width: 576px) {
        .transfer-filters .dates .filter-col {
            width: 50%;
        }

        .transfer-filters .states .filter-col {
            width: 50%;
        }
    }

    /* Small devices (landscape phones, 576px and up) */
    @media (max-width: 767px) {
        .transfer-filters .dates.border-after:after, .transfer-filters .states.border-after:after {
            display: none;
        }
    }

    /* Medium devices (tablets, 768px and up) (col-sm) */
    @media (min-width: 768px) and (max-width: 991px) {

        .transfer-filters .states {
            width: calc(100% - 410px);
        }

        .transfer-filters .states.border-after:after {
            display: none;
        }

        .transfer-filters .states .filter-col {
            width: 50%;
        }

        .transfer-filters .customer .name {
            width: 60%;
        }

        .transfer-filters .customer .room-no-flight {
            width: 50%;
        }
    }

    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) and (max-width: 1199px) {

        .transfer-filters .states {
            width: calc(100% - 410px);
        }

        .transfer-filters .states.border-after:after {
            display: none;
        }

        .transfer-filters .states .filter-col {
            width: 50%;
        }

        .transfer-filters .customer .name {
            width: 60%;
        }

        .transfer-filters .customer .room-no-flight {
            width: 50%;
        }

        .transfer-filters .more {
            width: 100%;
        }

        .transfer-filters .more .filter-col {
            width: 33.33333333%;
        }
    }

    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {

        .transfer-filters .customer {
            width: calc(100% - 688px);
        }

        .transfer-filters .customer .name {
            width: 60%;
        }

        .transfer-filters .customer .room-no-flight {
            width: 50%;
        }

        .transfer-filters .more {
            width: 100%;
        }

        .transfer-filters .more .filter-col {
            width: 33.33333333%;
        }
    }
</style>

